<div class="interaction-results">
  <div class="results-header">
    <div class="search-container">
      <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
      <input type="text" [(ngModel)]="searchText" [placeholder]="'SEARCH.PLACEHOLDER.RESULTS' | translate"
        class="search-input" />
      @if (searchText) {
      <button class="clear-button" (click)="clearSearch()" [title]="'FILTER.CLEAR_SEARCH' | translate">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
      }
    </div>
    @if (canCompare) {
    <button class="compare-button" (click)="navigateToCompare()">
      <fa-icon [icon]="faCodeCompare"></fa-icon>
      {{ 'COMPARE.COMPARE_SELECTED' | translate }} ({{ compareSelection.size }})
    </button>
    }
    @if (compareSelection.size === 1) {
    <span class="compare-hint">{{ 'COMPARE.SELECT_ONE_MORE' | translate }}</span>
    }
  </div>

  <app-item-list [items]="filteredListItems" [loading]="loadingResults" [config]="listConfig"
    [hasActiveFilters]="!!searchText" [selectedItems]="compareSelection"
    (itemClick)="onItemClick($event)" (actionClick)="onActionClick($event)"
    (itemSelectionChanged)="onItemSelectionChanged($event)">
  </app-item-list>

  <app-modal-view-log [show]="showLogModal" [interactionId]="interactionId" [resultId]="selectedResultId"
    (close)="onCloseLogModal()">
  </app-modal-view-log>

  <app-modal-delete-confirm [show]="showDeleteModal" [configKey]="resultToDelete?.name || ''" [configType]="'resultado'"
    (close)="onCloseDeleteModal()" (confirm)="onConfirmDelete()">
  </app-modal-delete-confirm>

  @if (showExecutionDetailsModal) {
  <app-modal-execution-details [interactionId]="interactionId"
    [resultId]="selectedResultForDetails?.id?.toString() || ''" (close)="onCloseExecutionDetails()">
  </app-modal-execution-details>
  }
</div>
